import { motion } from "framer-motion";
import "./SectionDivider.css";

export default function SectionDivider() {
  return (
    <motion.div
      className="section-divider-dashed"
      initial={{ opacity: 0, scaleX: 0 }}
      whileInView={{ opacity: 1, scaleX: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 1.2, ease: "easeOut" }}
      aria-hidden="true"
    />
  );
}
